<template>
  <div class="v-container">
    <div class="v-page-header">地域列表</div>
    <div class="v-header">
      <el-button v-if="level == 1" @click="showAddStreet()" size="small" type="primary">新增镇级</el-button>
      <el-button v-if="level == 2" @click="showAddArea()" size="small" type="primary">新增村级</el-button>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table :data="lists" row-key="id" :tree-props="{ children: 'child' }" default-expand-all height="100%" size="small" border>
        <el-table-column label="地域名称" prop="name" />
        <el-table-column label="展示风格" width="150">
          <template v-if="scope.row.level == 3" slot-scope="scope">
            <span v-if="scope.row.ext.spread == 1">三图</span>
            <span v-if="scope.row.ext.spread == 2">四图</span>
            <span v-if="scope.row.ext.spread == 3">四+一图</span>
            <span v-if="scope.row.ext.spread == 4">五图</span>
            <span v-if="scope.row.ext.spread == 5">六图</span>
            <span v-if="scope.row.ext.spread == 6">一图</span>
            <span v-if="scope.row.ext.spread == 7">二图</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="100" prop="sort" />
        <el-table-column align="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.level == 2" @click="showAddArea(scope.row.id)" size="min" class="v-ml-5" type="success">新增村级</el-button>
            <el-button @click="showEdit(scope.row)" size="min" class="v-ml-5" type="warning">编辑</el-button>
            <el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
              <el-button slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-edit-street v-if="isShowAddEditStreet" :show.sync="isShowAddEditStreet" :row="row" @success="getList"></add-edit-street>
    <add-edit-area v-if="isShowAddEditArea" :show.sync="isShowAddEditArea" :row="row" :pid="pid" @success="getList"></add-edit-area>
  </div>
</template>

<script>
import addEditStreet from './components/add-edit-street';
import addEditArea from './components/add-edit-area';

export default {
  components: { addEditStreet, addEditArea },

  data() {
    return {
      loading: false,
      lists: [],
      row: null,
      pid: 0,
      isShowAddEdit: false,
      isShowAddEditStreet: false,
      isShowAddEditArea: false,
      level: this.$store.getters.userInfo.level,
    };
  },

  created() {
    if (this.level == 3) {
      this.$router.replace('/vr-list');
      return;
    }
    this.getList();
  },

  methods: {
    async getList() {
      this.loading = true;
      try {
        let res = await this.api.region.lists();
        this.lists = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    showAddStreet() {
      this.row = null;
      this.isShowAddEditStreet = true;
    },

    showAddArea(pid) {
      this.row = null;
      this.pid = pid;
      this.isShowAddEditArea = true;
    },

    showEdit(row) {
      this.row = row;
      if (row.level == 2) {
        this.isShowAddEditStreet = true;
      }
      if (row.level == 3) {
        this.isShowAddEditArea = true;
      }
    },

    //删除
    async doDelete(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.region.delete({ id: row.id });
        this.$store.dispatch('user/getAreaList', true);
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: flex-end;
}
</style>
